export default function stringifyNumber(number) {
    if (number !== "") {
        return parseInt(number) >= 10 ? String(number) : "0" + parseInt(number);
    } else {
        return "";
    }
}